"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.sort");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.split");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var Input =
/*#__PURE__*/
_native["default"].TextInput(function (_ref) {
  var theme = _ref.theme;
  return {
    borderWidth: 1,
    borderColor: theme.borderColor || '#e6e6e6',
    borderRadius: 2,
    fontSize: 13,
    padding: 5,
    margin: 10,
    color: theme.labelColor || 'black'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9BcnJheS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJYyIsImZpbGUiOiIuLi8uLi9zcmMvdHlwZXMvQXJyYXkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vbmF0aXZlJztcblxuY29uc3QgSW5wdXQgPSBzdHlsZWQuVGV4dElucHV0KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJvcmRlcldpZHRoOiAxLFxuICBib3JkZXJDb2xvcjogdGhlbWUuYm9yZGVyQ29sb3IgfHwgJyNlNmU2ZTYnLFxuICBib3JkZXJSYWRpdXM6IDIsXG4gIGZvbnRTaXplOiAxMyxcbiAgcGFkZGluZzogNSxcbiAgbWFyZ2luOiAxMCxcbiAgY29sb3I6IHRoZW1lLmxhYmVsQ29sb3IgfHwgJ2JsYWNrJyxcbn0pKTtcblxuZnVuY3Rpb24gZm9ybWF0QXJyYXkodmFsdWUsIHNlcGFyYXRvcikge1xuICBpZiAodmFsdWUgPT09ICcnKSB7XG4gICAgcmV0dXJuIFtdO1xuICB9XG4gIHJldHVybiB2YWx1ZS5zcGxpdChzZXBhcmF0b3IpO1xufVxuXG5jb25zdCBBcnJheVR5cGUgPSAoeyBrbm9iLCBvbkNoYW5nZSB9KSA9PiAoXG4gIDxJbnB1dFxuICAgIGlkPXtrbm9iLm5hbWV9XG4gICAgdW5kZXJsaW5lQ29sb3JBbmRyb2lkPVwidHJhbnNwYXJlbnRcIlxuICAgIGF1dG9DYXBpdGFsaXplPVwibm9uZVwiXG4gICAgdmFsdWU9e2tub2IudmFsdWUuam9pbihrbm9iLnNlcGFyYXRvcil9XG4gICAgb25DaGFuZ2VUZXh0PXsoZSkgPT4gb25DaGFuZ2UoZm9ybWF0QXJyYXkoZSwga25vYi5zZXBhcmF0b3IpKX1cbiAgLz5cbik7XG5cbkFycmF5VHlwZS5kZWZhdWx0UHJvcHMgPSB7XG4gIGtub2I6IHt9LFxuICBvbkNoYW5nZTogKHZhbHVlKSA9PiB2YWx1ZSxcbn07XG5cbkFycmF5VHlwZS5wcm9wVHlwZXMgPSB7XG4gIGtub2I6IFByb3BUeXBlcy5zaGFwZSh7XG4gICAgbmFtZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgICB2YWx1ZTogUHJvcFR5cGVzLmFycmF5LFxuICAgIHNlcGFyYXRvcjogUHJvcFR5cGVzLnN0cmluZyxcbiAgfSksXG4gIG9uQ2hhbmdlOiBQcm9wVHlwZXMuZnVuYyxcbn07XG5cbkFycmF5VHlwZS5zZXJpYWxpemUgPSAodmFsdWUpID0+IHZhbHVlO1xuQXJyYXlUeXBlLmRlc2VyaWFsaXplID0gKHZhbHVlKSA9PiB7XG4gIGlmIChBcnJheS5pc0FycmF5KHZhbHVlKSkgcmV0dXJuIHZhbHVlO1xuXG4gIHJldHVybiBPYmplY3Qua2V5cyh2YWx1ZSlcbiAgICAuc29ydCgpXG4gICAgLnJlZHVjZSgoYXJyYXksIGtleSkgPT4gWy4uLmFycmF5LCB2YWx1ZVtrZXldXSwgW10pO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgQXJyYXlUeXBlO1xuIl19 */");

function formatArray(value, separator) {
  if (value === '') {
    return [];
  }

  return value.split(separator);
}

var ArrayType = function ArrayType(_ref2) {
  var knob = _ref2.knob,
      onChange = _ref2.onChange;
  return _react["default"].createElement(Input, {
    id: knob.name,
    underlineColorAndroid: "transparent",
    autoCapitalize: "none",
    value: knob.value.join(knob.separator),
    onChangeText: function onChangeText(e) {
      return onChange(formatArray(e, knob.separator));
    }
  });
};

ArrayType.defaultProps = {
  knob: {},
  onChange: function onChange(value) {
    return value;
  }
};
ArrayType.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].array,
    separator: _propTypes["default"].string
  }),
  onChange: _propTypes["default"].func
};

ArrayType.serialize = function (value) {
  return value;
};

ArrayType.deserialize = function (value) {
  if (Array.isArray(value)) return value;
  return Object.keys(value).sort().reduce(function (array, key) {
    return [].concat(_toConsumableArray(array), [value[key]]);
  }, []);
};

var _default = ArrayType;
exports["default"] = _default;